import { useCallback, useMemo, useState } from 'react';
import ModalContext from '../context/ModalContext';
import FormModal from './FormModal';

function ModalContainer({ formContext = {}, currentFormData = {}, getCurrentFormObject = () => null, scope = {} }) {
  const [modal, setModal] = useState();

  const openModal = useCallback((modal, ...args) => {
    let resolve = null;
    let reject = null;

    const promise = new Promise((_resolve, _reject) => {
      resolve = value => {
        setModal();
        _resolve(value);
      };

      reject = () => {
        setModal();
        _reject();
      };
    });
    setModal({
      modal,
      args,
      promise,
      resolve,
      reject,
    });

    return promise;
  }, []);

  const handle = useMemo(
    () => ({
      openModal,
    }),
    []
  );

  return (
    <>
      <ModalContext.SetValue value={handle} />
      {modal ? (
        <FormModal
          modalDef={modal}
          formContext={formContext}
          formData={currentFormData?.current}
          getCurrentFormObject={getCurrentFormObject}
          scope={scope}
        />
      ) : null}
    </>
  );
}

export default ModalContainer;
